import script from "./PegadaDeCarbono.vue?vue&type=script&setup=true&lang=js"
export * from "./PegadaDeCarbono.vue?vue&type=script&setup=true&lang=js"

import "./PegadaDeCarbono.vue?vue&type=style&index=0&id=4d308a74&lang=postcss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d308a74"]])

export default __exports__